import {
  Button,
  Card,
  CardContent,
  Form,
  InputImage,
  InputTextArea,
} from "@sellar-io/components";
import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { useForm, useWatch } from "react-hook-form";
import { InputLabel, InputContainer } from "@sellar-io/components";
import { useFirebaseImageUpload } from "../../../hooks/useFirebaseImageUpload";
import { useSupplierUpdate } from "../../../hooks/api/v2/supplier/useSupplierUpdate";

type FormType = {
  logoUrl: string | null | undefined;
  imageUrl: string | null | undefined;
  description: string | null | undefined;
};

export const StorefrontSettingsImageUpload = ({
  supplier,
}: {
  supplier: SupplierGetResponseType;
}) => {
  const supplierUpdateMutation = useSupplierUpdate(supplier.id);
  const uploadImage = useFirebaseImageUpload();

  const form = useForm<FormType>({
    shouldUseNativeValidation: true,
    defaultValues: {
      logoUrl: supplier.Business.logoUrl,
      imageUrl: supplier.imageUrl,
      description: supplier.description,
    },
  });
  const logoUrl = useWatch({
    control: form.control,
    name: "logoUrl",
  });
  const imageUrl = useWatch({
    control: form.control,
    name: "imageUrl",
  });

  const onSubmit = (data: Partial<FormType>) => {
    supplierUpdateMutation.mutate({
      Business: {
        logoUrl: data.logoUrl,
      },
      imageUrl: data.imageUrl,
      description: data.description,
    });
  };
  return (
    <Card className="bg-white">
      <CardContent className={"p-4"}>
        <Form
          className={"flex flex-col gap-4"}
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <div className="">
            <InputLabel>Logo</InputLabel>
            <InputImage
              value={logoUrl ?? ""}
              uploadFile={uploadImage}
              onChange={(e) => {
                form.setValue("logoUrl", e ?? "");
                onSubmit({
                  logoUrl: e,
                });
              }}
            />
          </div>

          <div className="">
            <InputLabel>Hero image</InputLabel>
            <InputImage
              value={imageUrl ?? ""}
              uploadFile={uploadImage}
              onChange={(e) => {
                form.setValue("imageUrl", e ?? "");
                onSubmit({
                  imageUrl: e,
                });
              }}
            />
          </div>

          <div className="">
            <InputLabel>Description</InputLabel>
            <InputContainer>
              <InputTextArea
                variant="legacyFixed"
                {...form.register("description", {
                  required: false,
                  disabled: supplierUpdateMutation.isPending,
                })}
                placeholder={"Tell customers about your brand."}
                className={"h-[90px]"}
              />
            </InputContainer>
          </div>

          <div className="flex justify-end">
            <Button
              className="flex justify-end"
              type={"submit"}
              // className={"w-full"}
              loading={supplierUpdateMutation.isPending}
              disabled={!form.formState.isDirty}
            >
              Save changes
            </Button>
          </div>
        </Form>
      </CardContent>
    </Card>
  );
};
